import { render, staticRenderFns } from "./forgotPWD.vue?vue&type=template&id=c33535be&"
import script from "./forgotPWD.vue?vue&type=script&lang=js&"
export * from "./forgotPWD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports